export class TileActionHarnessController {
  constructor() {}

  public onButtonClicked() {
    alert("Action was clicked!");
  }
}
